import { memo } from 'react'

import Chip from '@mui/material/Chip'

import {
  chipProps,
  FiltersBlock,
  FiltersResult
} from 'src/components/shared/filters-result'

const CashbackFiltersResult = ({
  t,
  filterCategories,
  onListItemClick,
  onClearAll,
  sx
}) => {
  return (
    <FiltersResult t={t} onClearAll={onClearAll} sx={sx}>
      <FiltersBlock
        label={`${t('common.category')}: `}
        isShow={!!filterCategories.length}
      >
        {filterCategories?.map(({ seoFriendlyId, name }) => (
          <Chip
            {...chipProps}
            key={seoFriendlyId}
            label={name}
            onDelete={() => onListItemClick(seoFriendlyId)}
          />
        ))}
      </FiltersBlock>
    </FiltersResult>
  )
}

export default memo(CashbackFiltersResult)
